export function Fab({ onClick, label }: { onClick: () => void; label: string }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className="fixed right-5 z-20 flex h-14 w-14 items-center justify-center rounded-full bg-plum-700 text-cream-50 shadow-[0_10px_28px_-6px_rgba(110,45,73,0.5)] transition-transform active:scale-95"
      style={{ bottom: "calc(5.75rem + env(safe-area-inset-bottom))" }}
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" className="h-6 w-6">
        <path d="M12 5v14M5 12h14" strokeLinecap="round" />
      </svg>
    </button>
  );
}
